/* min-order-guard.js */
const MIN_ORDER_AGOROT = 100; // 1₪ = 100 אגורות

async function getCart() {
  const res = await fetch('/cart.js', { credentials: 'same-origin' });
  return res.json();
}

function toggleCheckout(disabled, msgText = '') {
  const selectors = [
    'button[name="checkout"]',
    'form[action$="/checkout"] [type="submit"]',
    'a[href*="/checkout"]',
    '.shopify-payment-button button',
    '.shopify-payment-button__button'
  ];
  document.querySelectorAll(selectors.join(',')).forEach(btn => {
    if (disabled) {
      btn.setAttribute('disabled', 'disabled');
      btn.classList.add('is-disabled');
      btn.style.opacity = '0.5';
      btn.style.pointerEvents = 'none';
    } else {
      btn.removeAttribute('disabled');
      btn.classList.remove('is-disabled');
      btn.style.opacity = '';
      btn.style.pointerEvents = '';
    }
  });

  let msg = document.querySelector('[data-min-order-msg]');
  if (!msg) {
    msg = document.createElement('div');
    msg.setAttribute('data-min-order-msg', 'true');
    msg.style.marginTop = '8px';
    msg.style.fontSize = '14px';
    msg.style.color = '#d00';
    const target = document.querySelector('.cart__footer, .drawer__footer, form[action$="/cart"]') || document.body;
    target.appendChild(msg);
  }
  msg.textContent = msgText;
}

async function enforceMinOrder() {
  try {
    const cart = await getCart();
    const total = cart.total_price; // באגורות
    const underMin = total < MIN_ORDER_AGOROT;

    if (cart.item_count === 0) {
      // עגלה ריקה – אין מה לחסום
      toggleCheckout(false, '');
      return;
    }

    if (underMin) {
      toggleCheckout(true, 'לא ניתן לבצע הזמנה חינם.');
    } else {
      toggleCheckout(false, '');
    }
  } catch (e) {
    // במקרה של שגיאה לא לחסום בטעות
    toggleCheckout(false, '');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  enforceMinOrder();
  // טריגרים נפוצים בתמות שונות
  document.addEventListener('cart:updated', enforceMinOrder);
  document.addEventListener('product:added', enforceMinOrder);

  // פולבק: מעקב אחרי שינויים בדומ
  const obs = new MutationObserver(() => enforceMinOrder());
  obs.observe(document.body, { childList: true, subtree: true });
});
console.log("✅ min-order-guard loaded");